__turbopack_context__.v({
  "content": "Header-module-scss-module__wS1-Va__content",
  "wrapper": "Header-module-scss-module__wS1-Va__wrapper",
});
